export default __webpack_public_path__ + "static/plp--reposado--mobile-991eab8b4a987ade12046437e9d6cae8.jpg";